
import { Vue, Component } from 'vue-property-decorator';
import { SystemIsUpdate } from '@/service';

@Component({
    name: 'update',
})
export default class Update extends Vue {
    private $message!: any;
    public async canIUse() {
        try {
            const { rt_code, msg, data } = await SystemIsUpdate();
            if (rt_code === 0) {
                if (+data.option_value !== 0) {
                    this.$message('系统正在升级中，请稍后再试');
                } else {
                    this.$router.replace({ name: 'home' });
                }
            }
        } catch (error) {
            console.warn(error);
            this.$message('网络错误');
        }
    }
}
